import { api } from "./api";

export const ordersService = {
  list: (params = {}) =>
    api.get("/orders/mine", { params }).then((r) => r.data),

  /**
   * Admin-only: all users' orders. Accepts the same params as `list` plus
   * `user_ids` (comma-separated).
   */
  listAll: (params = {}) =>
    api.get("/admin/orders/all", { params }).then((r) => r.data),

  get: (id) => api.get(`/orders/${id}`).then((r) => r.data),

  cancel: (id, reason) =>
    api
      .post(`/orders/${id}/cancel`, reason ? { reason } : {})
      .then((r) => r.data),

  create: (payload) =>
    api.post("/orders", payload).then((r) => r.data),

  update: (id, patch) =>
    api.patch(`/orders/${id}`, patch).then((r) => r.data),

  submitDraft: (id) =>
    api.post(`/orders/${id}/submit`).then((r) => r.data),

  deleteDraft: (id) =>
    api.delete(`/orders/${id}`).then((r) => r.status),

  availability: (from, until, product_ids) =>
    api
      .get("/products/availability", {
        params: { from, until, product_ids: product_ids?.join(",") },
      })
      .then((r) => r.data),
};
